import { render } from "./SaySomethingNiceForm.vue?vue&type=template&id=9617c9de&scoped=true"
import script from "./SaySomethingNiceForm.vue?vue&type=script&lang=js"
export * from "./SaySomethingNiceForm.vue?vue&type=script&lang=js"

import "./SaySomethingNiceForm.vue?vue&type=style&index=0&id=9617c9de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9617c9de"]])

export default __exports__